import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "../components/AuthShell";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const findQuestion = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setQuestion(data.security_question);
      setStep(2);
    } catch (err) { setError(formatApiError(err)); } finally { setLoading(false); }
  };

  const doReset = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, security_answer: answer, new_password: newPassword });
      toast.success("Password reset. You can now sign in.");
      nav("/login");
    } catch (err) { setError(formatApiError(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell heading="Reset password" subtitle="Recover access using your security question.">
      {error && <div className="border border-danger/40 bg-danger/10 text-danger text-sm px-3 py-2 mb-4" data-testid="forgot-error">{error}</div>}
      {step === 1 ? (
        <form onSubmit={findQuestion} className="space-y-5" data-testid="forgot-step1">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full rounded-none h-11" disabled={loading} data-testid="forgot-continue">
            {loading ? "Checking…" : "Continue"}
          </Button>
        </form>
      ) : (
        <form onSubmit={doReset} className="space-y-5" data-testid="forgot-step2">
          <div className="space-y-2">
            <Label>Security Question</Label>
            <div className="border border-border bg-muted px-3 py-2 text-sm" data-testid="forgot-question">{question}</div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="ans">Your Answer</Label>
            <Input id="ans" value={answer} onChange={(e) => setAnswer(e.target.value)} required data-testid="forgot-answer" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="np">New Password</Label>
            <Input id="np" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required data-testid="forgot-newpassword" placeholder="Min 8 chars" />
          </div>
          <Button type="submit" className="w-full rounded-none h-11" disabled={loading} data-testid="forgot-reset">
            {loading ? "Resetting…" : "Reset Password"}
          </Button>
        </form>
      )}
      <p className="text-sm text-muted-foreground text-center mt-6">
        <Link to="/login" className="text-primary hover:underline font-medium">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
